import { createTranslations } from '@npco/utils-translations'

export const taxFileNumberFieldTranslations = createTranslations({
  taxFileNumber: 'Tax File Number',
  requiredTaxFileNumber: 'Tax File Number is required.',
  tooltip: 'Used to report any interest earned during the financial year',
})
